import DocumentationButton from "components/DocumentationButton";
import { EmptystateStacksColored } from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";
import { getDocsUrl } from "utils/getDocsUrl";
import Tooltip from "ds/components/Tooltip";
import useCanCreateStack from "shared/Stack/access/useCanCreateStack";

import { Widget } from "../types";

type DashboardResourcesChartEmptyNoStacksProps = {
  widget?: Widget;
};

const DashboardResourcesChartEmptyNoStacks = ({
  widget,
}: DashboardResourcesChartEmptyNoStacksProps) => {
  const canCreateStack = useCanCreateStack();

  return (
    <TileWrapper padding="x-large" fullWidth justify="center">
      <EmptyState
        title="You don’t have any stacks yet"
        icon={EmptystateStacksColored}
        caption="Start creating your stacks to see the resources breakdown."
      >
        <Box gap="medium">
          <DocumentationButton
            to={getDocsUrl("/concepts/stack")}
            label="Documentation"
            analyticsPage={AnalyticsPageDashboard.Dashboard}
            analyticsTitle="Widget - Documentation Clicked"
            analyticsProps={{ widget }}
          />
          <Tooltip
            active={!!canCreateStack.message}
            on={(tooltipProps) => (
              <LinkButton
                {...tooltipProps}
                variant="primary"
                to="/new/stack"
                disabled={!canCreateStack.result}
              >
                Create stack
              </LinkButton>
            )}
          >
            {canCreateStack.message}
          </Tooltip>
        </Box>
      </EmptyState>
    </TileWrapper>
  );
};

export default DashboardResourcesChartEmptyNoStacks;
